$(document).ready(function () {
    
    // The "Shop" navigation should display a sub-menu when hovered.
    
    const menu = document.querySelector('.header__inline-menu #Details-HeaderMenu-2');
    menu.addEventListener("mouseenter", () => {
        menu.setAttribute("open", true);
    });
    menu.addEventListener("mouseleave", () => {
        menu.removeAttribute("open");
    });

  
  // filter collection all page
  $('.filter-name-catelog-filter').click(function (e) {
    let targetId = $(this).attr('href').split('#')[1]; 
    let targetElement = $('#' + targetId);
  
    if (targetElement.length) {
      let scrollOffset = targetElement.offset().top;
      
      // Apply  only on mobile screens
      if ($(window).width() <= 768) {
        scrollOffset -= 100;
      }
  
      $('html, body').animate({ scrollTop: scrollOffset }, 500);
    }
  
    $(this).addClass('active').siblings().removeClass('active');
  });


});

function updateCartDrawer() {
  // Fetch cart data and update the cart drawer
    const _cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Logic to update cart drawer UI based on the cart object
      // This part needs to be customized based on your theme's cart drawer structure
      console.log(cart); // For debugging
      // Open the cart drawer
      fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(res => res.json())
      .then(data => {
        const drawerHtml = data['cart-drawer']; // section ID key
        cart.sections = data;
        const quickAddModal = document.querySelector('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { _cart.renderContents(cart) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          _cart.renderContents(cart);
        }
      });
      document.querySelector('.drawer').classList.remove("is-empty");
      document.querySelector('.drawer').classList.add("active");
    });
}